import { MaterialSymbol, getContrastColor, BodyText } from 'vopay';
import { FC } from 'react';
import { CircularProgressbar as OriginalCircularProgressbar } from 'react-circular-progressbar';
import { CircularProgressbarWrapperProps } from 'react-circular-progressbar/dist/types';
import 'react-circular-progressbar/dist/styles.css';
import styles from './ProgressGraph.module.scss';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';

// react-circular-progressbar hasn't updated its types for React 19 (not even as of 2025-May-30)
const CircularProgressbar = OriginalCircularProgressbar as unknown as FC<CircularProgressbarWrapperProps>;

type ProgressGraphProps = {
  remaining: number;
  total: number;
  pathStrokeColor: string;
  trailStrokeColor?: string;
  arrowPosition?: string;
  width?: string;
  height?: string;
};

const ProgressGraph: FC<ProgressGraphProps> = ({
  remaining = 0,
  total = 0,
  width = '100px',
  height = '100px',
  pathStrokeColor,
  trailStrokeColor = '#EFEFEF',
}) => {
  const { t } = useTranslation('translations', { keyPrefix: 'HomepageRevamp.Components.ProgressGraph' });
  const progress = remaining / total;
  const percentage = Math.round((1 - progress) * 10000) / 100;
  return (
    <>
      {
        <div className={styles.progressContainer} style={{ width, height }}>
          <div className={styles.textContainer}>
            <Title level="2">{isNaN(percentage) ? 0 : percentage}%</Title>
            <BodyText className={styles.bottomText}>{t('used')}</BodyText>
          </div>
          {progress >= 0.05 && (
            <div className={styles.chevrons} style={{ transform: `rotate(-${progress}turn)` }}>
              <div
                className={styles.chevronContainer}
                style={{
                  backgroundColor: pathStrokeColor,
                }}
              >
                <MaterialSymbol icon="keyboard_arrow_right" size="15px" color={getContrastColor(pathStrokeColor)} />
                <MaterialSymbol icon="keyboard_arrow_right" size="15px" color={getContrastColor(pathStrokeColor)} />
                <MaterialSymbol icon="keyboard_arrow_right" size="15px" color={getContrastColor(pathStrokeColor)} />
              </div>
            </div>
          )}

          <CircularProgressbar
            value={progress}
            maxValue={1}
            strokeWidth={5}
            counterClockwise
            styles={{
              path: {
                stroke: `${pathStrokeColor}`,
              },
              trail: {
                stroke: trailStrokeColor,
              },
              text: {
                fill: '#000',
                fontSize: '16px',
              },
            }}
          />
        </div>
      }
    </>
  );
};

export default ProgressGraph;
